import { useEffect, useState } from "react";
import { getSrcOfIframe } from "../embedUtilities";

const UseVimeoPreview = (url:string, isLoading: boolean, setIsLoading: any, setDisableUpload: any) => {
    const [id, setId] = useState<string>('');
  
    useEffect(() => {
      if (url) {
        setIsLoading(true)
        setId('');
        getVimeoId(url)
      }
    },[])

    useEffect(()=> {
      if (id) {
        setDisableUpload(false);
      } else {
        setDisableUpload(true);
      }
    }, [id])

    useEffect(()=> {
      if (isLoading && url){
        getVimeoId(url);
      }
    }, [isLoading])
  
    async function getVimeoId(vimeoUrl: string){  
      if(vimeoUrl.includes('<iframe')) {
        vimeoUrl = getSrcOfIframe(vimeoUrl);
      }

      if(!vimeoUrl.startsWith('http')) {
        vimeoUrl = `https://vimeo.com/${vimeoUrl}`
      }

      await fetchVimeoData(vimeoUrl);
    }

    async function fetchVimeoData(vimeoUrl) {
        try {
          const res = await fetch(`https://vimeo.com/api/oembed.json?url=${vimeoUrl}`);
          const data = await res.json();
          if (data.video_id) {
            setId(data.video_id);
          } else {
            setId('');
          }
        } catch (error) {
          console.error('Error fetching Vimeo data:', error);
          setId('');
        } finally {
          setIsLoading(false);
        }
      }      

    return {id}
}

export default UseVimeoPreview
